<script>
import axios from "axios";
import Swal from "sweetalert2";



export default {
  name: "table-nilai-substansi",
  props: {

  },
  emits: [
    'importNilai',
    'exportNilai'
  ],
  components: [],
  data() {

    return {
      id: this.$route.params.id,
      loadingTable: true,
      tableData: []
    }
  },
  mounted() {

    console.log("test");
    this.getDataNilaiSubstansi();
  },
  methods: {
    getDataNilaiSubstansi() {
      let self = this;
      self.loadingTable = true;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      // get data pembelajaran
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/detail/nilai-akademik",
        params: {
          id: self.id,
          namaTable: "substansi"
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config)
        .then(function (response) {
          if (response.status == 200) {
            self.loadingTable = false;
            self.tableData = response.data.data[0];

            console.log(response);
            Swal.close();
          } else {
            Swal.close();
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          Swal.close();
        });
    },

  }
}
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card-title mt-3">
        Nilai Substansi
      </div>
    </div>
    <div class="row mb-3">

      <div class="row mb-3">
        <div class="col-12 text-end">
          <b-button variant="info" size="sm" @click="$emit('importNilai')">
            <i class="fas fa-upload"></i>
            &nbsp;
            <b>Import Nilai </b>
          </b-button>
          &nbsp;
          <b-button variant="info" size="sm" @click="$emit('exportNilai')">
            <i class="fas fa-file-excel"></i>
            &nbsp;
            <b>Export Nilai </b>
          </b-button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <b-form>
        <div class="col-md-12">
          <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
            <thead class="greenTheme align-middle">
              <tr>
                <th class="text-center">NDH</th>
                <th class="text-center">Nama Peserta</th>
                <th class="text-center">Agenda 1</th>
                <th class="text-center">Agenda 2</th>
                <th class="text-center">Dibuat Oleh</th>
              </tr>
              <tr v-if="loadingTable == true">
                <td colspan="30"><i class="fas fa-spinner fa-spin"></i> loading . . .</td>
              </tr>
              <tr v-else-if="tableData == ''">
                <td colspan="30" class="text-center"><b>-- Data tidak ada --</b></td>
              </tr>
              <tr class="align-top" v-else v-for="(row_data, key_data) in tableData" :key="key_data">
                <td class="text-center">{{ key_data + 1 }}</td>
                <td>{{ row_data.user.name }}</td>
                <td class="text-center">
                  <span class="numberHover" :title="row_data.user.name + ' ' + row_data.substansi1">
                    {{ row_data.substansi1 }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="numberHover" :title="row_data.user.name + ' ' + row_data.substansi2">
                    {{ row_data.substansi2 }}
                  </span>
                </td>
                <td class="text-center">
                  {{ row_data.created_by }}
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <!-- <div class="col-md-12 p-3 pb-3 text-end">
            <b-button variant="success">
            <b>Simpan Perubahan</b>
            &nbsp;
            <i class="fas fa-check"></i>
            </b-button>
        </div> -->
      </b-form>
    </div>
  </div>
</template>